import { useNavigate } from 'react-router';
import { DotsMenu, MenuItem } from '~/commonComponents/DotsMenu';
import { CandidateStatus } from '~/domain/PermanentJobs';
import { useToggle } from '~/hooks';
import { ShareIcon } from '~/images/icons';
import { Colors } from '~/themes/colors';
import { InviteToExistingInterviewModal } from './InviteToExistingInterviewModal';

interface IInviteColumnCellProps {
  candidateId: string;
  jobPostingId: string;
  officeId: string;
  officeStatus: CandidateStatus;
  professionalId: string;
  professionalName: string;
}

export const InviteColumnCell = ({
  candidateId,
  jobPostingId,
  officeId,
  officeStatus,
  professionalId,
  professionalName,
}: IInviteColumnCellProps) => {
  const navigate = useNavigate();
  const [isInvitePopupOpen, controls] = useToggle();

  const isHired = officeStatus === CandidateStatus.Hired;
  const isRejected = officeStatus === CandidateStatus.Rejected;

  const canInvite = !isHired && !isRejected;

  const handleInviteNewInterviews = () => {
    navigate(`/permanent-jobs/postings/${jobPostingId}/onsite-interviews/create/work-details`, {
      state: {
        invitedProfessionals: [{ label: professionalName, value: professionalId }],
      },
    });
  };

  if (!canInvite) {
    return null;
  }

  return (
    <>
      <DotsMenu
        dataCy="invite-menu-button"
        position="bottom-right"
        CustomMenuIcon={() => (
          <button
            aria-label="Invite candidate"
            data-candidate-id={candidateId}
            data-job-posting-id={jobPostingId}
            data-testid="invite-column-cell"
            style={{ background: 'transparent', width: 'fit-content', marginLeft: 16 }}
          >
            <ShareIcon color={Colors.secondary_500} />
          </button>
        )}
      >
        <MenuItem dataCy="existing-interview" text="Existing Interview" onClick={controls.setOn} />
        <MenuItem dataCy="new-interview" text="New Interview" onClick={handleInviteNewInterviews} />
      </DotsMenu>
      <InviteToExistingInterviewModal
        isOpen={isInvitePopupOpen}
        professionalId={professionalId}
        jobPostingId={jobPostingId}
        officeId={officeId}
        onClose={controls.setOff}
      />
    </>
  );
};
